import { z } from 'zod';

import { FeeId, FeeLineItemId, LosId, PaymentDueId } from '../../BrandedIds';
import { FeeStatus, FeeType } from '../../events/CreateChargeEvent';
import { InvestorRemittanceSplit } from '../../loan/InvestorRemittanceSplit';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';
import { ExportableActor } from '../util/ExportableActor';

/**
 * One Fee <-> many FeeLineItems
 */
export const ExportableFeeLineItem = z
  .object({
    type: z.literal('fee'),
    id: FeeLineItemId,
    feeId: FeeId,
    loanId: LosId,

    amount: z.number(),
    lineItemType: FeeType,
    name: z.string().optional(),

    totalAmount: z.number(),
    amountRemaining: z.number(),
    status: FeeStatus,
    chargeDate: zodTemporalPlainDate,
    updatedAt: zodTemporalInstant.optional(),
    cancelledAt: zodTemporalInstant.optional(),
    cancelledBy: ExportableActor.optional(),
    comment: z.string().optional(),
    investorRemittanceSplit: InvestorRemittanceSplit.optional(),
    isDeferred: z.boolean(),
    createdAt: zodTemporalInstant.optional(),
    paymentDueId: PaymentDueId.optional(),
  })
  .meta({ title: 'FeeLineItem' });
export type ExportableFeeLineItem = z.infer<typeof ExportableFeeLineItem>;
